export const PROCESS_JOURNAL_UID = "processJournal";
export const JOURNAL_COMMENT_KEY = "projectComments";
export const PROJECT_COMMENT_KEY = "projectComments";
export const PROJECT_TASK_UID = "PROJECT_TASK";
export const PROJECT_PRESENTATION_UID = "PROJECT_PRESENTATION";
